class FooterDropdown extends HTMLElement{
    constructor(){
        super();
        this.button = this.querySelector("button");
        this.content = this.querySelector(".footer-details-content");

        this.button.addEventListener("click",this.handler.bind(this))
    }

    handler(){
        const expanded = this.button.classList.toggle("active");
        this.button.setAttribute("aria-expanded", expanded);
        this.content.inert = !expanded;
        if (!expanded) {
            this.content.style.maxHeight = null;
        } else {
            this.content.style.maxHeight = this.content.scrollHeight + "px";
        }
    }
}

customElements.define("footer-dropdown",FooterDropdown)